module.exports = __webpack_public_path__ + "static/media/气温.325e4ce3.svg";